<script setup lang="ts">
import { computed, withDefaults, defineProps } from 'vue';
import type { OperationInfo } from '@/types/v2/task/animal-transfer/operation.types';
import type { FishTransfer, GroupTag } from '@/types/v2';

interface Props {
    transferInfo?: OperationInfo;
    actualTransfers: FishTransfer[];
    newTags: GroupTag[];
}

const props = withDefaults(defineProps<Props>(), {
    transferInfo: undefined,
    actualTransfers: () => [],
    newTags: () => []
});

const headline = computed(() => props.transferInfo?.headline ?? '');
const mainDescription = computed(() => props.transferInfo?.description?.main ?? '');
const additionalDescription = computed(() => props.transferInfo?.description?.additional);
const showTags = computed(() => !!additionalDescription.value && props.actualTransfers.length > 0);
</script>

<template>
    <div v-if="transferInfo"
        class="group p-4 my-4 bg-amber-50 rounded-lg shadow-md ring-1 ring-amber-200 transition-all duration-200">
        <div class="flex flex-col gap-3">
            <h3 class="text-lg font-semibold text-amber-900">
                Required Operation: {{ headline }}
            </h3>
            <p class="text-amber-800">{{ mainDescription }}</p>
            <div v-if="additionalDescription" class="flex flex-wrap items-center gap-2">
                <p class="text-amber-800">{{ additionalDescription }}</p>
                <div v-if="showTags" class="flex flex-wrap gap-2">
                    <span v-for="tag in newTags" :key="tag.key"
                        class="px-2.5 py-1 text-xs font-medium rounded-md shadow-sm transition-colors duration-200"
                        :style="{
                            backgroundColor: tag.backgroundColor,
                            color: tag.textColor
                        }">
                        {{ tag.title }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>